// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1YIwo","productName":"Table_productName__19y1g"};